import { defineStore } from "pinia";
import { fetchUserWell } from "@/services/auth";
import { useAuthStore } from "@/stores/auth";

export const useDeviceStore = defineStore("device", {
  state: () => ({
    devices: [],
    activeDevice: null,
    activeArea:null,
    deviceDetails: {},
    isLoading: false, // 👈 برای مدیریت لودینگ
  }),
  getters: {
    groupedDevices(state) {
      const groups = {};
      for (const item of state.devices) {
        if (!groups[item.area_id]) {
          groups[item.area_id] = {
            area_id: item.area_id,
            name: item.name, // اسم منطقه
            items: [],
          };
        }
        groups[item.area_id].items.push(item);
      }
      return Object.values(groups);
    },
  },
  actions: {

    setDevices(devices) {
      this.devices = devices;
      //this.activeDevice = devices.length > 0 ? devices[0].data : null;
      this.activeArea = devices.length > 0 ?{id:devices[0].area_id,name:devices[0].name} : null;
    },
     setActiveArea(id,name) {
      this.activeArea = {id,name};
      //this.activeDevice = reactive({ ...item });
    },
    setActiveDevice(item) {
      this.activeDevice = item;
      //this.activeDevice = reactive({ ...item });
    },
    updateActiveDeviceStatusWell(status) {
      if (this.activeDevice) {
        this.activeDevice.status_well = status;
      }
    },
    updateActiveDeviceUserLocalID(userLocalID) {
      if (this.activeDevice) {
        this.activeDevice.user_local_id = userLocalID;
      }
    },
    async loadUserDevices() {
      this.isLoading = true; // 👈 شروع لودینگ
      try {
        const response = await fetchUserWell();
        this.setDevices(response.data.wells);
      
      } catch (error) {
        console.error("خطا در گرفتن دستگاه‌ها:", error);
        const authStore = useAuthStore();
       //authStore.logout();
      //window.location.href = "/login";
      } finally {
        this.isLoading = false; // 👈 پایان لودینگ
      }
    },

    reset() {
      const authStore = useAuthStore();
      authStore.logout();
      this.devices = [];
      this.activeDevice = null;
       this.activeArea = null;
      this.deviceDetails = {};
      this.isLoading = false;
    },
  },

  persist: true,
});
